module.exports = __webpack_public_path__ + "img/132.7b9272aa.gif";